import React from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { EnforcementTimeline } from "./EnforcementTimeline";
import { fetchTimeline } from "../../api/enforcementService";
export var RecordHistory = function (_a) {
    var recordId = _a.recordId;
    var kyInstance = useOkapiKy();
    var _b = useQuery(["deposit-record-timeline", recordId], function () { return fetchTimeline(kyInstance, recordId); }, { cacheTime: 60000 }).data, events = _b === void 0 ? [] : _b;
    return React.createElement(EnforcementTimeline, { events: events });
};
